import st from '../../pages/healthcare/styles.module.scss';
import React, { useState } from 'react';
import Pricing from '../video-production/Pricing';

const PageHeaderComponent = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  // const [loadedPricingModal,setLoadedPricingModal] = useState(false)

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      document.getElementById('pricing-form_test').reset();
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    // setLoadedPricingModal(false)
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <div className={`relative w-full  h-intro  overflow-hidden   `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src={props.url} type="video/mp4" />
        </video>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="capitalize text-white text-30 md:text-60  font-bolder leading-none max-w-800">{props.text}</h1>
            <div className={'cursor-pointer icon-green mt-23 md:mt-0'}>
              <style>{`
                                    .icon-green .icon-calculator-container .icon-calculator {
                                        filter: brightness(0) invert(1) !important;
                                    }
                                     .card-rounded{
                                          border-radius: 20px 20px 20px 20px;
                                        }
                                        .bg-review{
                                          background-size:cover!important;
                                         background-position: bottom!important;
                                         height:320px;
                                       }
                                          @media screen and (max-width:768px){
                                             .bg-review{
                                               /*// background:unset;*/
                                               height:unset;
                                             }
                                         }
                                `}</style>
              <a
                onClick={showPricingModal}
                className="calculate-price-header relative z-10  md:inline-block border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-5 bg-green-badge hover:bg-green-hover hover:text-white transition-all icon-calculator-container transition-400"
              >
                <span className="icon icon-calculator" />
                Get Pricing
              </a>
            </div>
          </div>
        </div>
      </div>

      <Pricing id={'test'} videoLength={[]} script={''} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};
export default PageHeaderComponent;
